export default {
  /**
   * @param state
   * @returns {[]}
   */
  getAddons(state) {
    const addons = [];
    console.log(state.addons);
    state.addons.items.forEach(addon => {
      addons.push({ ...addon });
    });
    return addons.filter(addon => {
      if (!state.addons.search) {
        return true;
      }
      const searchIn = addon.addonName;
      return searchIn.toLowerCase()
        .indexOf(state.addons.search.toLowerCase()) !== -1;
    });
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/ski/visitgroup/getters.js